import useCategoriesSelect from 'modules/categories/hooks/use-categories-select';
import useCreateSubCategory, {
  CreateSubCategoryProps,
  translatedCreateSubCategoryProps,
} from 'modules/sub-categories/hooks/use-create-sub-category';

import React from 'react';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateSubCategory: React.FC = () => {
  const {getInput, getSwitch, getSelect} =
    useFormInputs<CreateSubCategoryProps>();

  const {data, isLoading} = useCategoriesSelect();

  return (
    <Creation<CreateSubCategoryProps>
      titleBar={{title: 'Cadastrar sub categoria'}}
      defaultValues={{active: true}}
      onSubmit={useCreateSubCategory}
      inputs={[
        getInput({
          name: 'name',
        }),
        getSelect({name: 'categoryId', data, isLoading}),
        getSwitch({
          name: 'active',
        }),
      ]}
      translationKey={translatedCreateSubCategoryProps}
    />
  );
};

export default CreateSubCategory;
